import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import user from "./user";
Vue.use(Vuex);
let timeOut;

const store = new Vuex.Store({
    state: {
        loading: false,
        serverStatus: true,
        needUpdate: false
    },
    mutations: {
        setLoadingState(state, isLoading) {
            state.loading = Boolean(isLoading);
        },
        serverError(state) {
            state.serverStatus = false;
            state.loading = false;
            if (timeOut) {
                clearTimeout(timeOut);
            }
            timeOut = setTimeout(() => {
                state.serverStatus = true;
            }, 4000);
        },
        needUpdate(state, needUpdate) {
            state.needUpdate = Boolean(needUpdate);
        }
    },
    actions: {},
    getters: {
        loading: state => state.loading,
        serverStatus: state => state.serverStatus,
        needUpdate: state => state.needUpdate
    },
    modules: {
        user
    },
    plugins: [
        createPersistedState({
            key: "admin",
            paths: ["user"]
        })
    ]
});
export default store;
